// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1068":"css/admin-app.6719","9116":"css/app.6719"}[chunkId] + ".css";
};